var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#404040",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0457 9.02307L13.9385 16.8455C13.6629 17.1297 13.3034 17.25 12.9499 17.25C12.5964 17.25 12.2381 17.1304 11.9613 16.8913L2.85409 9.02307C2.2771 8.52016 2.25314 7.68926 2.79777 7.16449C3.3448 6.63425 4.25852 6.61785 4.83131 7.11529L12.9499 14.1287L21.0685 7.10983C21.6414 6.61271 22.5514 6.63152 23.102 7.16107C23.6448 7.68926 23.6209 8.52016 23.0457 9.02307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/AngleDown.65a3383ae1210ebbe312950b41a09acd.svg";
export { ForwardRef as ReactComponent };